import * as React from "react";

function SvgHubspot(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 13.107 13.099"
      preserveAspectRatio="xMidYMid"
      {...{ ...props, ref }}
    >
      <path
        d="M12.027 6.222a3.33 3.33 0 00-1.209-1.201 3.26 3.26 0 00-1.223-.424V3a1.17 1.17 0 00.722-1.097 1.2 1.2 0 00-1.2-1.206 1.21 1.21 0 00-1.21 1.206c0 .49.26.908.707 1.097v1.588a3.49 3.49 0 00-1.064.334L3.275 1.685c.03-.113.056-.23.056-.353a1.336 1.336 0 10-1.335 1.336c.252 0 .485-.074.686-.195l.28.212L6.797 5.45a3.193 3.193 0 00-.543.636c-.306.485-.493 1.018-.493 1.6v.12a3.35 3.35 0 00.21 1.156c.116.316.286.604.497.864l-1.274 1.277a1.027 1.027 0 00-1.387.968 1.033 1.033 0 002.065 0 1.03 1.03 0 00-.048-.31l1.316-1.316c.18.125.375.23.585.32a3.42 3.42 0 001.369.288h.09c.552 0 1.073-.13 1.562-.395a3.23 3.23 0 001.224-1.153 3.02 3.02 0 00.475-1.63v-.03c0-.587-.136-1.128-.42-1.624zM10.42 8.984c-.357.397-.768.642-1.232.642H9.1c-.265 0-.525-.073-.778-.207a1.8 1.8 0 01-.682-.621 1.448 1.448 0 01-.284-.845v-.09c0-.296.057-.577.2-.842.153-.3.36-.515.635-.694s.558-.265.88-.265h.03c.29 0 .567.057.827.19a1.75 1.75 0 01.65.591 1.88 1.88 0 01.291.83l.007.187c0 .407-.156.784-.467 1.126z"
        fill="#f8761f"
      />
    </svg>
  );
}

export default React.forwardRef(SvgHubspot);
